import { CoreTypography } from '@youscience/core';

import DeleteChipIcon from '@images/delete-chip.svg?react';

import { sxStyles, StyledChip } from './Chip.styles';
import { Skeleton } from '@mui/material';

export type Color = 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success' | 'disabled';
export type Size = 'small' | 'medium' | 'large';

interface ChipProps {
  title: string;
  onDelete?: () => void;
  color?: Color;
  size?: Size;
  isLoading?: boolean;
}

export const Chip = (props: ChipProps) => {
  const { title, size = 'medium', color = 'default', onDelete, isLoading } = props;

  return (
    <StyledChip chipSize={size} chipColor={isLoading ? 'disabled' : color}>
      <CoreTypography sx={sxStyles.title}>{isLoading ? <Skeleton width="4rem" height={24} /> : title}</CoreTypography>
      {onDelete ? <DeleteChipIcon onClick={onDelete} /> : null}
    </StyledChip>
  );
};
